import React from 'react'
import Link from 'gatsby-link'
import Hero from '../components/Hero'
import styled from 'styled-components'
import Action from '../components/Action'
import Helmet from 'react-helmet'

const FAQ = () => (
  <div>
    <Helmet>
      <title>FAQ - shotsnapp</title>
      <meta
        name="description"
        content="Frequently Asked Questions for Shotsnapp"
      />
    </Helmet>
    <Wrapper>
      <Hero title="FAQ" subtitle="You have questions? We have the answers." />
      <Content>
        <div className="container">
          <div className="content">
            <ul>
              <li>
                <h4>What is shotsnapp?</h4>
                <p>
                  shotsnapp is a web-based tool that lets you create beautiful
                  device mockup images to show off your mobile app or website
                  either using your design file or screenshots. All you need to
                  do is to choose what device to show it off on, and upload your
                  image for it to be show on the device you chose.
                </p>
              </li>
              <li>
                <h4>What can I use shotsnapp for?</h4>
                <p>
                  You can use shotsnapp for any purpose imaginable. Designers
                  can use it to show their progress or to show them off in their
                  portfolio. Manager can use it for presentations and
                  dicussions. Marketers can use it to generate image for
                  Facebook posts or any other social media sites. Make sure to
                  see our Use Case page to see more examples.
                </p>
              </li>
              <li>
                <h4>Is it free?</h4>
                <p>
                  The basic functionality of shotsnapp is available for free for
                  anyone to use. However, there are some limitations imposed to
                  free users. For example, you can only use one object in a
                  design. To add multiple objects, you have to upgrade to PRO
                  accounts. Learn more about the other advantages of{' '}
                  <a target="_blank" href="https://app.shotsnapp.com/upgrade">
                    upgrading to PRO here
                  </a>.
                </p>
              </li>

              <li>
                <h4>Why do I have to pay to use certain features?</h4>
                <p>
                  shotsnapp is developed by a one-man team, trying to build the
                  best possible tool for its job. By paying a small amount of
                  fee, you are helping the continuos maintainance of the
                  project. The fee will also fund future development and
                  improvement plans for the project in the long run.
                </p>
              </li>
              <li>
                <h4>How do I upgrade to shotsnapp PRO?</h4>
                <p>
                  You can go to{' '}
                  <a target="_blank" href="https://app.shotsnapp.com/upgrade">
                    upgrade
                  </a>{' '}
                  page and create a PRO account.
                </p>
              </li>
              <li>
                <h4>Does shotsnapp store my credit card details?</h4>
                <p>
                  We do not store your payment information in our system.
                  Payment processing on shotsnapp is handled by a large and
                  reputable third-party payment company called{' '}
                  <a target="_blank" href="https://paddle.com">
                    Paddle
                  </a>. Our order process is conducted by our online reseller
                  Paddle.com. Paddle.com is the Merchant of Record for all our
                  orders. Paddle provides all customer service inquiries and
                  handles returns.
                </p>
              </li>
              <li>
                <h4>I am a PRO user. How do I cancel my subscription?</h4>
                <p>
                  PRO account in shotsnapp is not a subscription - it's a
                  one-time payment. After your PRO period ended, it will not be
                  auto-renewed. So, you don't have to worry about being charged.
                  You can always pay again if you wished to continue.
                </p>
              </li>
              <li>
                <h4>Can I request for a refund?</h4>
                <p>
                  No, we do not allow refund. Once you paid, you have access to
                  all the PRO features.
                </p>
              </li>
              <li>
                <h4>Why does my browser is not supported?</h4>
                <p>
                  Due to some technical limitations on how shotsnapp works in
                  generating the final images, Safari and Microsoft Edge support
                  is currently unavailable. You might be able to use all the
                  features, but you won't be able to download the final image.
                  We are working to figure out ways to improve this. In the
                  meantime, it's encouraged to use Chrome or Firefox browsers.
                </p>
              </li>
              <li>
                <h4>How do I contact shotsnapp for other inquiries?</h4>
                <p>
                  For a more private and confidential related inquries (i.e
                  payment, troubleshooting, etc), please send an email with
                  related information to shotsnapp@gmail.com. For a more casual
                  inquiries (i.e tips, how-tos, suggestions), you can Tweet or
                  DM us on at{' '}
                  <a href="http://twitter.com/tryshotsnapp" target="_blank">
                    @tryshotsnapp
                  </a>. We will try out best to serve you :)
                </p>
              </li>
            </ul>
          </div>
        </div>
      </Content>
      <Action />
    </Wrapper>
  </div>
)

export default FAQ

const Wrapper = styled.div`
  background: #4e00d9;
  background-image: linear-gradient(-148deg, #3a4380 0%, #202443 100%);
`
const Content = styled.div`
  min-height: 800px;
  .content {
    padding: 40px;
    border-radius: 5px;
    background-color: #fff;
    @media (max-width: 600px) {
      padding: 25px;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    li {
      margin-bottom: 40px;
      h4 {
        font-size: 20px;
        margin: 0 0 8px;
      }
      p {
        line-height: 1.5;
      }
      a {
        color: #0070dd;
        &:hover {
          color: #004cd4;
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/faq.js